import ApisServiceApp from './ApisServiceApp'

/**
 * Auth — `POST /api/v1/auth/login` (baseURL `/api/v1` + `/auth/login`).
 * Body: `{ username, password }`
 */
export function authLogin(username: string, password: string) {
  return ApisServiceApp.post('/auth/login', { username, password })
}

/**
 * `POST /api/v1/users/sso/dang-nhap` — đăng nhập nhân viên (trang `/login`).
 */
export function login(username: string, password: string) {
  return ApisServiceApp.post('/users/sso/dang-nhap', { username, password })
}

/** `POST /users/sso/dang-xuat` — ghi nhật ký đăng xuất (token xóa phía client). */
export function logSsoLogout() {
  return ApisServiceApp.post('/users/sso/dang-xuat', {}, { timeout: 3000 })
}

export function logout(refreshToken: string) {
  return ApisServiceApp.post('/auth/logout', { refreshToken })
}

export function refreshToken(refreshToken: string) {
  return ApisServiceApp.put('/users/sso/lam-moi-token', { refreshToken })
}

/**
 * `PUT /users/sso/lam-moi-token` sau khi đã có access từ login — gửi Bearer, body rỗng.
 */
export function refreshSsoSession() {
  return ApisServiceApp.put('/users/sso/lam-moi-token', {})
}

export function loginCustomer(code: string, password: string) {
  return ApisServiceApp.post('/khach-hang/dang-nhap', {
    code,
    password,
  })
}

export function logoutCustomer(refreshToken: string) {
  return ApisServiceApp.post('/khach-hang/dang-xuat', { refreshToken })
}

export function refreshTokenCustomer(refreshToken: string) {
  return ApisServiceApp.post('/khach-hang/lam-moi-token', { refreshToken })
}

/** `GET /users/sso/du-an-cua-toi` — Lấy danh sách dự án của tôi */
export function getMyDuAn() {
  return ApisServiceApp.get('/users/sso/du-an-cua-toi')
}

/** `GET /users/sso/chi-nhanh-cua-toi` — Lấy danh sách chi nhánh của tôi */
export function getMyChiNhanh() {
  return ApisServiceApp.get('/users/sso/chi-nhanh-cua-toi')
}

/** `GET /users/sso/menu-cua-toi` — Lấy menu của tôi */
export function getMyMenu() {
  return ApisServiceApp.get('/users/sso/menu-cua-toi')
}

/**
 * `PUT /api/v1/users/sso/{duAnId}/{chiNhanhId}/doi-chinhanh` — Đổi chi nhánh.
 * Response gợi ý: `access_token` / `accessToken`, `duAn`, `chiNhanh`, (tuỳ chọn) `refresh_token`.
 */
export function changeBranch(duAnId: number, chiNhanhId: number) {
  return ApisServiceApp.put(`/users/sso/${duAnId}/${chiNhanhId}/doi-chinhanh`, {})
}
